export default "__VITE_ASSET__BjdnHK4Y__"